module.exports = __webpack_public_path__ + "static/logo-01631bb0a6c3344debf39b20b1603ca1.png";